import { EnvironmentProviders, Provider } from '@angular/core';
import { MAT_DATE_LOCALE } from '@angular/material/core';

export const dateLocaleProvider: Provider[] | EnvironmentProviders = [
  { provide: MAT_DATE_LOCALE, useValue: 'it-IT' },
];
